var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fnlo65bsza",
    width: 44,
    height: 40,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blurOut",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    result: "floodOut"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "floodOut",
    in2: "blurOut",
    operator: "atop"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    slope: 0.1,
    type: "linear"
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fnlo65bsza)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBC658",
    fillRule: "evenodd",
    d: "M39.25 30.998L24.23 4.947c-1.154-2.001-4.05-2.004-5.206 0L4.004 30.998c-1.153 1.999.29 4.507 2.602 4.507h30.041c2.308 0 3.758-2.504 2.603-4.507zm-17.623-5.386c1.59 0 2.879 1.289 2.879 2.88s-1.289 2.881-2.879 2.881-2.88-1.29-2.88-2.881c0-1.591 1.29-2.88 2.88-2.88zm-2.734-10.354c-.023-.43.319-.792.75-.792h3.968c.431 0 .773.362.75.792l-.465 8.516c-.021.399-.351.711-.75.711h-3.039c-.399 0-.728-.312-.75-.711l-.464-8.516z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.3a70b7d41de00dde8839a4942e9b352d.svg";
export { ForwardRef as ReactComponent };